import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const FilterGroupSkeletonLoader = () => {
    return (
        <SkeletonTheme baseColor="#f4f4f4" highlightColor="#fcfcfc">
            <div className="skeleton-container">
                <Skeleton count={1} height={10} containerClassName="flex-grow" />
                <Skeleton count={1} height={10} containerClassName="flex-1" />
                <Skeleton count={1} height={10} containerClassName="flex-1" />
            </div>
        </SkeletonTheme>
    );
};
